import { useCachedQueryInfinite } from '@packages/shared/core/queryCache/hooks';
import type { QueryCacheInfiniteProviderOptions } from '@packages/shared/core/queryCache/entities';
import type { ExpertReview, ExpertReviewsGetKey, ExpertReviewsInfiniteKey } from '../entities';

type UseExpertReviewsInfiniteQueryParams = {
  getKey: ExpertReviewsGetKey;
  options?: QueryCacheInfiniteProviderOptions<Array<ExpertReview>, { message: string }>;
};

export const useExpertReviewsInfiniteQuery = ({ getKey, options }: UseExpertReviewsInfiniteQueryParams) => {
  const { data, isLoading, isValidating, error, size, setSize } = useCachedQueryInfinite<
    Array<ExpertReview>,
    ExpertReviewsInfiniteKey
  >(
    getKey,
    ({ services }) =>
      (key) => {
        const { expertService } = services;
        const { page, per_page, filter, sort } = key;

        return expertService.getExpertReviews(key.expertId, {
          page,
          per_page,
          filter,
          sort,
        });
      },
    options,
  );

  return {
    reviews: data,
    areReviewsLoading: isLoading || isValidating,
    errorLoadingReviews: error?.message ?? '',
    size,
    setSize,
  };
};
